let authKey = '__al_a';

export default {
  namespaced: true,
  
  state: () => {
    let token = window.localStorage.getItem(authKey);

    return {
      token,
      user: null,
      pages: {}
    }
  },

  // getters: {
  //   isLogged(state){
  //     return state.user;
  //   }
  // },

  mutations: {
    login(state, data){
      if (data.token) state.token = data.token;
      if (data.user) state.user = data.user;
      if (data.pages) state.pages = data.pages;
    },

    update(state, {user, pages}){
      state.user = user || state.user;
      state.pages = pages || state.pages;
    },

    logout(state){
      state.token = null;
      state.user = null;
      state.pages = {};
    }
  },

  actions: {
    login({commit}, data){
      // Set to storage
      if (data.token) window.localStorage.setItem(authKey, data.token);
      commit('login', data);
    },

    logout({commit}){
      window.localStorage.removeItem(authKey);
      commit('logout');
    }
  }
};
